// extracted by mini-css-extract-plugin
export default {"genreLink":"Genre__genreLink--D105S"};